/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na rodiče při komunikaci s přehrávačem PDF.
 */
class PdfParentFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<PdfParent>} PdfParent
   * @param {PenpalConnectToChild} connectToChild
   * @param {string} origin Origin, který budou mít zprávy od potomka.
   * @param {number} timeout Maximální doba čekání na navázání komunikace. [ms]
   * @returns {undefined}
   */
  constructor(PdfParent, connectToChild, origin, timeout) {
    this.PdfParent = PdfParent;
    this.connectToChild = connectToChild;
    this.origin = origin;
    this.timeout = timeout;
  }

  /**
   * Vytvoří nového rodiče.
   * @param {HTMLIFrameElement} iframe Iframe, do kterého se načte potomek s PDF prohlížečem.
   * @returns {PdfParent}
   */
  create(iframe) {
    return new this.PdfParent(
      this.connectToChild,
      iframe,
      this.origin,
      this.timeout
    );
  }
}

export default PdfParentFactory;
